<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">

            <el-row>
              <el-col :span="12" class="item">
                <el-form-item label="残疾人" required prop="userName">
                  <el-input v-model="addForm.userName" placeholder="请选择残疾人人" disabled>
                    <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" class="item">
                <el-form-item label="用药组名称" required prop="groupName">
                  <el-input v-model="addForm.groupName"  placeholder="请输入用药组名称"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="item">
                <el-form-item label="用药详情" required prop="itemNameArr">
                  <div style="width:100%;margin-top:40px">
                    <el-tag
                        :key="tag"
                        v-for="tag in addForm.itemNameArr"
                        closable
                        :disable-transitions="false"
                        @close="handleClose(tag)">
                      {{tag}}
                    </el-tag>

                    <el-input
                        class="input-new-tag"
                        v-if="inputVisible"
                        v-model="inputValue"
                        ref="saveTagInput"
                        size="small"
                        @keyup.enter.native="handleInputConfirm"
                        @blur="handleInputConfirm">
                    </el-input>
                    <el-button v-else class="button-new-tag" size="small" @click="showInput">+ 药品添加</el-button>

                  </div>
                </el-form-item>
              </el-col>
            </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

    <GetElderly ref="myGetElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false"
                v-on:setElderly="setElderly"></GetElderly>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import GetElderly from "@/views/Elderly/Comm/ElderlyInsCheckIn2";

export default {
  name: 'Add',
  props:['setmealList'],
  data() {
    return {
      loading: false,
      showModalGetElderly: false,


      type:'',

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        userCode:'',
        userName:'',
        elderlyCode:'',
        groupName:'',
        itemNameArr:[],
      },

      inputVisible: false,
      inputValue: '',

      rules:{
        groupName:[
          { required: true, message: '请输入用药组名称', trigger: 'blur' },
        ],
        itemNameArr:[
          { required: true, message: '请输入药品名称', trigger: 'blur' },
        ],
        userName:[
          { required: true, message: '请选择老人', trigger: 'blur' }
        ]
      }



    }
  },
  components:{
    GetElderly
  },
  methods: {
    init(type){
      this.type = type;
      this.$refs.addForm.resetFields();
    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    handleClose(tag) {
      this.addForm.itemNameArr.splice(this.addForm.itemNameArr.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(value => {
        console.log(value)
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.addForm.itemNameArr.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myGetElderly.init(this.type);
    },
    setElderly(row){
      this.addForm.userCode=row.userCode;
      this.addForm.userName = row.name;
      this.addForm.elderlyCode = row.elderlyCode;
    },

    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"MedicationGroup/GovAdd",
        data: this.addForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeAdd");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },


  }
}


</script>
<style>
.el-tag{
  margin-right: 10px;
}
.button-new-tag {
  height: 35px;
  line-height: 35px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 120px;
  vertical-align: bottom;
}
</style>
<style lang="scss" scoped>


</style>
